module.exports = __webpack_public_path__ + "static/media/profile.df875d3f.jpg";